import { render, staticRenderFns } from "./ListSchoolYear.vue?vue&type=template&id=ae6a2e12&scoped=true"
import script from "./ListSchoolYear.vue?vue&type=script&lang=js"
export * from "./ListSchoolYear.vue?vue&type=script&lang=js"
import style0 from "./ListSchoolYear.vue?vue&type=style&index=0&id=ae6a2e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6a2e12",
  null
  
)

export default component.exports